import  { useState } from 'react';
import api from '../api/api';  
import { useNavigate } from 'react-router-dom';

export default function Register() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const handleRegister = async (e) => {  //appelee lors de la soumission
    e.preventDefault();
    setError('');
    setSuccess('');

    if (password !== confirm) {
      setError('Les mots de passe ne correspondent pas.');
      return;  
    }
 // ANSSI-style password rule
  const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d).{12,}$/;

  if (!passwordRegex.test(password)) {
    setError(
      'Le mot de passe doit contenir au moins 12 caractères avec au moins une lettre et un chiffre.'
    );
    return;
  }
      //envoie des données au backend
    try {
      const res = await api.post('/auth/register', { username, password });  //appel APIAxios (backend)
      console.log('Inscription réussie:', res.data);
      setSuccess('Compte créé avec succès. Redirection vers la connexion...');
      setTimeout(() => navigate('/login'), 1500);
    } catch (err) {
      if (err.response && err.response.status === 409) // this is not good, wait.
        setError('Nom d’utilisateur déjà pris.');
      else setError('Erreur lors de la création du compte.');
    }
  };

  return (
    <div className="container">
      <h2>Inscription</h2>
      <form onSubmit={handleRegister}>
        <input
          placeholder="Nom d’utilisateur"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Mot de passe"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Confirmer le mot de passe"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          required
        />
        <button type="submit">Créer le compte</button>
           <p>
          Déjà un compte ? <a href="/login">Connectez-vous</a>
        </p>
      </form>
      {error && <p className="error">{error}</p>}
      {success && <p className="success">{success}</p>}
    </div>
  );
}
